<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.42 30.32">
    <g v-if='!active'>
      <circle class="transparent" cx="11.48" cy="11.48" r="10.38"/>
      <line class="cls-1" x1="17.57" y1="20.74" x2="24.56" y2="29.64"/>
    </g>
    <g v-if='active'>
      <line class="cls-1" x1="23.56" y2="23.56"/><line class="cls-1" x1="0.05" x2="23.62" y2="23.56"/>
    </g>
  </svg>
</template>

<style scoped>
  svg {
    height: 1.75em;
    margin-left: 2em;
    margin-top: 0.5em;
    overflow: visible;
  }

  g {
    fill:none;
    stroke: var(--blue);
    stroke-miterlimit:10
    ;stroke-width:3px;
  }

  .transparent {
    fill: transparent;
  }
</style>

<script>
export default {
  props: ['active'],
}
</script>
